import { render, staticRenderFns } from "./ProjectCriteria.vue?vue&type=template&id=0b7785b5&"
import script from "./ProjectCriteria.vue?vue&type=script&lang=js&"
export * from "./ProjectCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports